// 'mixpanel' var is defined in the '_mixpanel.js' file which is included in the HTML

export default class MixpanelService {
  static track(eventName, properties) {
    if (!this.checkMixpanel()) {
      return;
    }

    mixpanel.track(eventName, properties);
  }

  static checkMixpanel() {
    if (typeof mixpanel === "undefined") {
      console.warn("Mixpanel is not initialized.");
      return false;
    }
    return true;
  }

  static getId() {
    if (!this.checkMixpanel()) {
      return;
    }
    return mixpanel.get_distinct_id();
  }

  static identify(email) {
    if (!this.checkMixpanel()) {
      return;
    }
    mixpanel.identify(email);
  }

  static trackGivingButtonClick(campaignName) {
    this.track("giving_button_click", {
      "Campaign Name": campaignName,
    });
  }

  static trackGivingFormClick(step, button, isMatchingGift = false) {
    if (isMatchingGift) {
      this.track("matching_gift_form_click", {
        "Form Page": step,
        Button: button,
      });
      return;
    }
    this.track("giving_form_click", {
      "Form Page": step,
      Button: button,
    });
  }

  static async trackCreateMatchingGiftClick(entityName) {
    this.track("create_match_a_gift_form_click", {
      "Button Clicked": "Create Matching Gift",
      "Entity Name": entityName,
    });
  }

  static trackShareClick(medium) {
    this.track("social_click", {
      Medium: medium,
    });
  }

  static trackAdminEmailSend(userId, mailingId, estimatedRecipientCount) {
    this.track("email_sent", {
      "User Id": userId,
      "Email Id": mailingId,
      "Total Sent": estimatedRecipientCount,
    });
  }
}
